export const HEADER_ENUM = {
  docsButton: "Docs",
  loginButton: "Login",
  sendButton: "Send",
  fairexText: "Fairex",
};
